import React, { Fragment } from 'react';
import { func, instanceOf, number } from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import {
  setSurveyInfo,
  getIECategories,
} from '../../../actions/turnkeyOmnibusActions';

import IENoSettingsDataFound from './IENoSettingsDataFound';

const setDropdownData = data => {
  if (data) {
    return data.map((item, i) => ({
      ...item,
      value: item.pn,
      label: item.sd,
      latest: i === 0,
    }));
  }
  return [];
};

const getStudy = (array, key) => {
  if (key && array.length > 0) {
    return array.find(item => item.value === key);
  }
  return null;
};

const StudySelection = ({
  setSurveyInfo,
  ieStudies,
  study,
  getIECategories,
  categoryId,
  surveyId,
}) => {
  if (ieStudies.length === 0) {
    return (
      <IENoSettingsDataFound title="Select Study" message="No Study Found." />
    );
  }

  const state = {
    study: getStudy(ieStudies, study ? study.pn : null),
  };

  const handleOnChange = val => {
    if (val) {
      const defaultValue = {
        pn: null,
        sti: '',
        sd: null,
        wt: null,
        dv: null,
        st: '',
      };
      const studyInfo = val ? getStudy(ieStudies, val) : defaultValue;
      const {
        pn = null,
        sti = '',
        sd = null,
        wt = null,
        dv = null,
        st = '',
      } = studyInfo;
      setSurveyInfo({
        study: {
          pn,
          sti,
          sd,
          wt,
          dv,
          st,
        },
      });
      if (sti !== study.sti) {
        getIECategories(sti);
        setSurveyInfo({ categoryId: null, categoryName: '' });
      }
    }
  };

  const customOptions = option => {
    if (option.latest) {
      return (
        <span className="ie--settings--study--latest">
          <strong>* {option.label}</strong>
        </span>
      );
    }
    return option.label;
  };

  const renderDropdown = () => {
    return (
      <Select
        options={ieStudies}
        className="ie--autoselect"
        onChange={handleOnChange}
        value={state.study}
        placeholder="Select for Study"
        id="study-select"
        simpleValue
        name="study-select"
        searchable
        optionRenderer={customOptions}
        valueRenderer={customOptions}
        disabled={surveyId && categoryId}
        clearable={false}
        arrowRenderer={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            id="magnify"
          >
            <path d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5-1.5 1.5-5-5v-.79l-.27-.27A6.516 6.516 0 0 1 9.5 16a6.5 6.5 0 1 1 0-13m0 2C7 5 5 7 5 9.5S7 14 9.5 14 14 12 14 9.5 12 5 9.5 5z" />
          </svg>
        )}
      />
    );
  };

  return (
    <Fragment>
      <div className="ie--card ie--settings--study">
        <div className="ie--card--body">
          <div className="ie--card--col">
            <h2 className="ie--card--title">Select Study</h2>
            <div className="ie--settings--form">{renderDropdown()}</div>
            <div className="ie--settings--message">
              Turn-Key Omnibus is a do-it-yourself proprietary insights
              generator that fuses data to a MRI-Simmons National Study.
              <br />
              By default, the most recent available study will be appended to
              your Turn-Key Omnibus. Feel free to choose another study from the
              selection menu.
            </div>
          </div>
          <div className="ie--card--col">
            <h3 className="ie--card--title">Selection</h3>
            {state.study && (
              <div className="ie--settings--selection">
                {state.study.latest ? (
                  <span>* {state.study.label}</span>
                ) : (
                  state.study.label
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="ie--settings--study--default">
        * Most recent study available.
      </div>
    </Fragment>
  );
};

StudySelection.propTypes = {
  ieStudies: instanceOf(Array),
  setSurveyInfo: func.isRequired,
  getIECategories: func.isRequired,
  study: instanceOf(Object),
  categoryId: number,
  surveyId: number,
};

StudySelection.defaultProps = {
  study: {
    pn: null,
    sti: null,
    sd: '',
  },
  ieStudies: [],
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { ieStudy, surveyInfo } = turnkeyOmnibus;
  return {
    ieStudies: setDropdownData(ieStudy.data),
    study: surveyInfo.study,
    categoryId: surveyInfo.categoryId,
    surveyId: surveyInfo.surveyId,
  };
};

export default connect(
  mapStateToProps,
  { setSurveyInfo, getIECategories }
)(StudySelection);
